export const CHANGE_VENUE_ALIAS= 'CHANGE_VENUE_ALIAS'
export const CHANGE_VENUE_ALIAS_SUCCESS= 'CHANGE_VENUE_ALIAS_SUCCESS'
export const CHANGE_VENUE_ALIAS_ERROR='CHANGE_VENUE_ALIAS_ERROR'

export const ChangeVenueAlias= (data) => ({
    type: CHANGE_VENUE_ALIAS,
    payload: data
})